










































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import StepNavigation from '@ui/AudienceSetWizard/StepNavigation'
import PartnershipSteps from '@ui/AudienceSetWizard/PartnershipStep/PartnershipSteps'
import BrandSelector from '@ui/AudienceSetWizard/components/BrandSelector'

settings =
  name: 'PartnershipSponsorStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      Modal,
      StepContainer,
      StepNavigation,
      PartnershipSteps,
      BrandSelector,
    }

    data: ->
      sponsorSetModal:
        show: false
        sponsor: {}

    computed:
      actionsForStepNavigation: ->
        beforeNext: @wizard.hiPreview

    methods:
      hiAddSponsorSet: ->
        @sponsorSetModal.show = true

      hiCloseSponsorSetModal: ->
        @closeSponsorModal()

      hiSaveSponsorSetModal: ->
        { sponsor } = @sponsorSetModal
        sponsor.key = @wizard.generateRandomKey()
        @wizard.audienceSetData.pitch.sponsor_set.push sponsor
        @closeSponsorModal()
        @wizard.syncAndSave()

      hiRemoveSponsorSet: (sponsorSet) ->
        @wizard.audienceSetData.pitch.sponsor_set = @wizard.audienceSetData.pitch.sponsor_set.filter((s) -> s.key isnt sponsorSet.key)
        @wizard.syncAndSave()

      closeSponsorModal: ->
        @sponsorSetModal =
          show: false
          sponsor: {}

export default VueOptions.vue settings
